import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-duotone-svg-icons/faStar'
import { toast } from 'react-toastify'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

class MultiContentDossierFavorite extends Component {
    constructor(props) {
        super(props)

        this.state = {
            favoritesDefDossierForm:
                this.props.favorite === true ? true : false,
            done: 0,
            total: this.props.items.length,
        }

        this.addFavorites = this.addFavorites.bind(this)

        this.toastOptions = {
            position: 'bottom-center',
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    }

    addFavorites(favorites) {
        let total = this.props.items.length
        let items = this.props.items
        let itemsDone = 0
        const kedo = this.props.kedo
        this.setState({
            favorites: favorites,
        })

        items.map((dossierId) => {
            let url = kedo
                .api()
                .getContentDossierFavoriteEndpoint(dossierId, favorites)

            kedo.api()
                .post(url)
                .then((response) => {
                    itemsDone = itemsDone + 1
                    if (itemsDone === total) {
                        this.handleExit()
                    } else {
                        this.setState({
                            done: itemsDone,
                        })
                    }
                })
        })
    }

    deleteFavorites(favorites) {
        let total = this.props.items.length
        let items = this.props.items
        let itemsDone = 0
        const kedo = this.props.kedo
        this.setState({
            favorites: favorites,
        })
        items.map((dossierId) => {
            let url = kedo
                .api()
                .getContentDossierFavoriteEndpoint(dossierId, favorites)

            kedo.api()
                .delete(url)
                .then((response) => {
                    itemsDone = itemsDone + 1
                    if (itemsDone === total) {
                        this.handleExit()
                    } else {
                        this.setState({
                            done: itemsDone,
                        })
                    }
                })
        })
    }

    handleExit() {
        this.props.onClose()
    }

    render() {
        if (this.props.showModal) {
            if (this.props.showActionModal === 'favorite') {
                this.addFavorites(),
                    toast.success(
                        this.props.kedo.t('dossier_errors.favorite_add'),
                        this.toastOptions
                    )
            } else {
                this.deleteFavorites(),
                    toast.success(
                        this.props.kedo.t('dossier_errors.favorite_remove'),
                        this.toastOptions
                    )
            }

            this.props.onClose()

            return
        }

        return (
            <span>
                <StyledButton
                    variant={'outlined'}
                    color="secondary"
                    onClick={() => {
                        this.addFavorites(),
                            toast.success(
                                this.props.kedo.t(
                                    'dossier_errors.favorite_add'
                                ),
                                this.toastOptions
                            )
                    }}
                >
                    <FontAwesomeIcon icon={faStar} />
                    &nbsp; {this.props.kedo.t('Favorite')}
                </StyledButton>
                <StyledButton
                    variant={'outlined'}
                    color="secondary"
                    onClick={() => {
                        this.deleteFavorites()
                        toast.success(
                            this.props.kedo.t('dossier_errors.favorite_remove'),
                            this.toastOptions
                        )
                    }}
                >
                    <FontAwesomeIcon icon={faStar} />
                    &nbsp; {this.props.kedo.t('Remove favorite')}
                </StyledButton>
            </span>
        )
    }
}

export default MultiContentDossierFavorite
